import { graphql } from 'parkdepot-shared/gql'

const GET_LOT_OCCUPANCY = graphql(`
    query b2c_get_lot_occupancy($lot_id: String!) {
        b2c_get_lot_occupancy(lot_id: $lot_id) {
            free_spots
            last_updated_at
            occupancy_distribution
        }
    }
`)

export default GET_LOT_OCCUPANCY
